import React from 'react';
import './Model.css';

const ViewMenuViewSize = ({ size, viewSize }) => {
  const n = [...Array(size).keys()];
  const backgroundColor = viewSize === size ? 'black' : '#999';
  return (
    <div id={size} className="frames_viewmenu_icon">
      {n.map((i) => (
        <div className="frames_viewmenu_icon_row" id={size} key={i}>
          {n.map((j) => (
            <div
              className="frames_viewmenu_icon_column"
              style={{ backgroundColor }}
              id={size}
              key={j}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default ({ viewSize, setViewSize }) => {
  const viewClick = (e) => {
    const targetViewSize = parseInt(e.target.id, 10);
    if (targetViewSize && targetViewSize >= 1 && targetViewSize <= 6) {
      setViewSize(targetViewSize);
    }
  };
  return (
    <div className="frames_viewmenu_sizes" onClick={viewClick}>
      <ViewMenuViewSize size={5} viewSize={viewSize} />
      <ViewMenuViewSize size={3} viewSize={viewSize} />
      <ViewMenuViewSize size={2} viewSize={viewSize} />
    </div>
  );
};

// <ViewMenuViewSize size={4} viewSize={viewSize} />
// <ViewMenuViewSize size={6} viewSize={viewSize} />
// <ViewMenuViewSize size={1} viewSize={viewSize} />
